import React from 'react'
import './style.css'
import { Upload as KendoUpload } from '@progress/kendo-react-upload';

export function Upload(props) {
    return (
        <KendoUpload
            {...props}
        />
    )
}
